import { AnyAction } from "redux";
import { ThunkAction } from "redux-thunk";
import { API_URL_RESET_ORDER } from "../../../../../constants";
import { RootState } from "../../../../../models";
import * as Ajax from "../../../app/Ajax";
import * as AT from "../actionTypes";

export const resetOrder = (): ThunkAction<void, RootState, unknown, AnyAction> => (dispatch) =>
    dispatch({
        type: AT.CHECKOUT_RESET_ORDER,
        payload: Ajax.get({ url: API_URL_RESET_ORDER }, dispatch),
    });
